import { domainEvent } from "@lookiero/messaging";
const NOTIFICATIONS_CLEARED = "notifications_cleared";
const notificationsCleared = ({ aggregateId }) => domainEvent({
    name: NOTIFICATIONS_CLEARED,
    aggregateId,
});
const isNotificationsCleared = (domainEvent) => domainEvent.name === NOTIFICATIONS_CLEARED;
export { NOTIFICATIONS_CLEARED, notificationsCleared, isNotificationsCleared };
